<template>
  <aha-modal title="The presentation is being edited by:" @hide="$emit('hide')">
    <div class="bg-secondary-10 p-2 flex items-center mb-3">
      <aha-avatar
        class="mr-2"
        :name="activeEditor.name"
        :image="activeEditor.avatar"
        :id="activeEditor.id"
        :width="28"
        :height="28"
      />
      <div class="flex flex-col">
        <span class="font-bold">
          <strong>{{ `${activeEditor.firstName} ${activeEditor.lastName}` }}</strong>
        </span>
        <span class="text-base-90">{{ activeEditor.email }}</span>
      </div>
    </div>
    <p>{{ $i18nPresenter.t("You can only view it.") }}</p>
    <template #action>
      <aha-link
        class="text-base-80 font-bold"
        @click="$emit('hide')"
      >
        {{ $i18nPresenter.t("Cancel") }}
      </aha-link>
      <aha-button
        has-margin-left
        variant="primary"
        @click="$emit('view')"
      >
        {{ $i18nPresenter.t("View now") }}
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>
export default {
  props: {
    activeEditor: {
      type: Object,
      default: null,
    },
  },
}
</script>
